"use client";

import { create } from "zustand";

interface ActiveStoreState {
    /** Loja ativa usada nas requisições. 0 = nenhuma resolvida. */
    storeId: number;
    /** true quando o StoreInit adotou a loja do SSR (fim do skeleton). */
    ready: boolean;
    setStoreId: (storeId: number) => void;
    setReady: (ready: boolean) => void;
}

/**
 * Loja ativa da aplicação — estado global client-only (nunca lido no SSR),
 * SÓ EM MEMÓRIA, e ÚNICA fonte client-side da loja em uso.
 *
 * A fonte de verdade é o cookie `selected_store` + a resolução do servidor
 * (`resolve-store.ts`): o StoreInit semeia este store com a loja que o SSR já
 * resolveu, e a troca de loja grava o cookie e pede `router.refresh()`.
 *
 * Deliberadamente SEM `persist`: um valor em localStorage era uma segunda
 * fonte de verdade que reidratava ANTES do StoreInit e, quando divergia do
 * cookie (cookie limpo, outra aba trocou a loja), dava a quem lê de forma
 * não-reativa (`getActiveStoreId`) a loja errada por uma janela.
 *
 * Componentes leem reativo com useActiveStore((s) => s.storeId); fora de React
 * (serviços/handlers), use getActiveStoreId().
 */
export const useActiveStore = create<ActiveStoreState>()((set) => ({
    storeId: 0,
    ready: false,
    setStoreId: (storeId) => set({ storeId }),
    setReady: (ready) => set({ ready }),
}));

/** Leitura não-reativa da loja ativa, para requisições fora de componentes. */
export const getActiveStoreId = (): number => useActiveStore.getState().storeId;
